import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  RedditShareButton,
  RedditIcon,
} from 'react-share';
import Image from 'next/image';
import breakPoints from 'helpers/Styles';

const ShareButtons = ({ url }) => {
  const [urlCopied, setUrlCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    setUrlCopied(true);
  };

  const title = 'Aftershock PC';
  const twitterHandle = 'aftershock';
  const tags = ['aftershock', 'custom-pc'];

  useEffect(() => {
    const timer = setTimeout(() => {
      if (urlCopied) {
        setUrlCopied(false);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [urlCopied]);

  return (
    <>
      <div className="share">
        <h1>SHARE YOUR RESULT</h1>
        <h3>Share to social media: </h3>
        <div className="socials">
          <FacebookShareButton url={url}>
            <FacebookIcon size={40} round />
          </FacebookShareButton>

          <TwitterShareButton
            url={url}
            title={title}
            via={twitterHandle}
            hashtags={tags}
          >
            <TwitterIcon size={40} round />
          </TwitterShareButton>

          <WhatsappShareButton url={url} title={title}>
            <WhatsappIcon size={40} round />
          </WhatsappShareButton>

          <RedditShareButton url={url} title={title}>
            <RedditIcon size={40} round />
          </RedditShareButton>
        </div>

        <h3>Copy link to clipboard</h3>
        <div className="copyLink">
          <div className="copy-input">
            <input type="text" value={url} disabled className="inputLink" />
          </div>
          <div className="copy">
            <button type="button" className="button" onClick={handleCopyLink}>
              {urlCopied ? 'COPIED' : 'COPY'}
            </button>
            <div className="copy-icon">
              <Image draggable={false}
                src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/copy.png?v=1714038331"
                alt="copy_icon"
                layout="fixed"
                width={30}
                height={30}
              />
            </div>
          </div>
        </div>
      </div>

      <style global jsx>
        {`
          .Results_modalContent__5J5kQ {
            max-width: 880px !important;
            height: 400px !important;
          }
          .react-share__ShareButton {
            margin-right: 30px;
            padding: 0 12px;
          }
          .inputLink {
            padding: 0 12px;
          }
          @media (max-width: ${breakPoints.small}) {
            .Results_modalContent__5J5kQ {
              max-width: 350px !important;
            }
          }
        `}
      </style>
      <style jsx>
        {`
          .share {
            width: 75%;
            margin: 0 auto;
            padding: 10px;
          }
          .share h1 {
            width: 50%;
            color: #e4e4e4;
            font-family: 'big_noodle_titling';
            font-size: 31px;
            letter-spacing: 0;
            line-height: 40px;
            margin: 0 auto;
            text-align: center;
            margin-bottom: 50px;
          }
          .share h3 {
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            letter-spacing: 0;
            line-height: 24px;
          }
          .copyLink {
            height: 48px;
            // width: 604px;
            border-radius: 2px;
            display: flex;
            justify-content: space-between;
          }
          .copy-input {
            border: 1px solid #242424;
            width: 484px !important;
            display: flex;
            height: 48px !important;
            justify-content: center;
            background-color: #141414 !important;
          }
          input {
            display: block;
            width: 484px;
            height: 48px !important;
            background-color: #141414 !important;
            outline: none;
            border: 0px;
            margin-right: 30px;
          }
          .copy {
            width: 160px !important;
            display: flex;
            justify-content: space-between;
          }
          .button {
            float: right;
            height: 48px;
            width: 100px;
            border-radius: 2px 0 0 2px;
            background-color: #950810;
            outline: none;
            border: 0px;
            color: #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
            margin-left: 20px;
          }
          .copy-icon {
            height: 48px;
            width: 60px;
            border-radius: 0 2px 2px 0;
            background-color: #222222;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .copyLink input {
            width: 100%;
            color: #e4e4e4;
            background-color: #000;
          }
          .socials {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
          }
          @media (max-width: ${breakPoints.small}) {
            .share {
              width: 100%;
              margin: 0 auto;
            }
            .copyLink {
              width: 100%;
            }
            .copy-input {
              width: 100% !important;
            }
          }
        `}
      </style>
    </>
  );
};

ShareButtons.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ShareButtons;
